// 📁 src/HomeIN.js
import HomeGlobal from "./HomeGlobal";
export default function HomeIN() {
  return <HomeGlobal />;
}
